// import external dependencies
import 'jquery';

// Import everything from autoload
import "./autoload/_bootstrap.js"

// import local dependencies
import Router from './util/Router';
import common from './routes/common';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

const job_link_name = "Careers";

const new_link = ` / <span property="itemListElement" typeof="ListItem"><a property="item" typeof="WebPage" title="Go to DeBlois Electric Careers." href="/careers" class="home"><span property="name">${job_link_name}</span></a><meta property="position" content="1"></span>`;
const list = document.querySelectorAll('.single-job_listing .listing-breadcrumbs > .container > span:nth-of-type(1)');
const list2 = document.querySelectorAll('.single-job_listing .breadcrumbs > span:nth-of-type(1)');

if(typeof list[0] != "undefined") {
  list[0].insertAdjacentHTML('beforeend', new_link);
}

if(typeof list2[0] != "undefined") {
  list2[0].insertAdjacentHTML('beforeend', new_link);
}


// WEBPACK FOOTER //
// ./scripts/main.js